/**
 * The one recovery this build knows how to perform.
 *
 * TEMPORARY and business-scoped on purpose. It is not a general repair tool and
 * must not become one: it republishes eight named records for one business, and
 * that is the entire reason `SyncSettingsScreen` shows a recovery panel at all.
 * Delete this file, its panel, and the marker it leaves behind once the Krishna
 * devices agree again.
 *
 * The list is exact rather than derived. A derived list ("everything missing from
 * the other device") cannot be computed here — this device has no view of the
 * other device's database — and a list that quietly grows is a list nobody
 * reviewed.
 *
 * ORDER IS MEANING. Parents precede children, because this array is the order the
 * outbox entries are written in, and therefore the order the receiving device
 * applies them: a document line applied before its document would be a line
 * pointing at nothing. `applyChanges` tolerates that, but there is no reason to
 * ask it to.
 *
 * `01M67WF586TXA56ASTX3PSAXWT` is the line Edge deleted. It is republished as a
 * DELETE at the version and timestamp the original deletion recorded — see
 * `planRepublish`, which refuses to plan it unless both are found.
 */
import {
  SUPPORT_REPUBLISH_BUSINESS_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_CHANGED_AT,
  SUPPORT_REPUBLISH_DELETED_LINE_CHANGE_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_DELETED_AT,
  SUPPORT_REPUBLISH_DELETED_LINE_SOURCE_DEVICE_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_VERSION,
  SUPPORT_REPUBLISH_TARGETS,
} from '@data/sync/republishEntities';

export {
  SUPPORT_REPUBLISH_BUSINESS_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_CHANGED_AT,
  SUPPORT_REPUBLISH_DELETED_LINE_CHANGE_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_DELETED_AT,
  SUPPORT_REPUBLISH_DELETED_LINE_SOURCE_DEVICE_ID,
  SUPPORT_REPUBLISH_DELETED_LINE_VERSION,
  SUPPORT_REPUBLISH_TARGETS,
};

/** A human label for the panel. Names the device requirement, not the business. */
export const SUPPORT_REPUBLISH_NOTE =
  'In Microsoft Edge, on the device that still has the records (the one showing 5 parties and 3 documents).';
